import "./Heading.css";
import ScrollAnimation from "../ScrollAnimation/ScrollAnimation";

const Heading = ({ bodyText = false, children }) => {
    return (
        <ScrollAnimation type="fade" delay={300}>
            <div className={`heading ${bodyText ? "body-text" : ""}`}>{children}</div>
        </ScrollAnimation>
    );
};

export default Heading;
